import { use } from "i18next"
import { AccountPaymentPlan } from "../account/AccountPaymentPlan"
import { useAccount, usePaymentPlan } from "../state/AppDataStateProvider"
import Container from "@mui/material/Container"

export const AccountPaymentPlanPage = ({accountId}) => {

    const account = useAccount()
    const payments = usePaymentPlan(account?.id)

    return (
        <Container maxWidth="md">
            <AccountPaymentPlan payments={payments} loading={false} error={false} />
        </Container>
    )
}